import React from "react";
import { FacilityOrderPatientNewFlowInsuranceInsuranceEditTemplate } from "themes/application/facility-order-new-flow-insurance/components";
import { observer } from "mobx-react";

@observer
class FacilityOrderPatientNewFlowInsuranceInsuranceEdit extends React.Component {
	render() {
		return <FacilityOrderPatientNewFlowInsuranceInsuranceEditTemplate {...this.props} />;
	}
}

export default FacilityOrderPatientNewFlowInsuranceInsuranceEdit;